/**
 * Guitar stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_everyday_formats`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const guitarStickersPack: ToilePack = {
    slug: 'guitar-stickers',
    category: 'sticker',
    name: 'Guitar stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'vinyl', label: 'Vinyl record', subject: 'a black vinyl record with a red centre label and a small lightning bolt across it'},
        {key: 'notes', label: 'Music notes', subject: 'a treble clef with three eighth notes floating off to the right'},
        {key: 'pick', label: 'Guitar pick', subject: 'a guitar pick with the words "Rock On" and a tiny star'},
    ],
    styles: [
        {key: 'vinyl', label: 'Glossy vinyl', style: 'glossy die-cut vinyl sticker, bold clean shapes with thick dark outlines, smooth gradient-free fills', palette: 'a bright limited palette of five flat colors', framing: 'Centered, with a thick white die-cut border and an even margin of background all round.'},
        {key: 'punk', label: 'Punk zine', style: 'photocopied punk-zine sticker, rough cut-paper shapes, heavy black outlines and grainy toner texture', palette: 'a palette of black, white and one hot pink', framing: 'Centered, with a ragged white die-cut border and an even margin of background all round.'},
        {key: 'sixties', label: 'Sixties psychedelic', style: 'sixties psychedelic poster sticker, flowing rounded shapes and wavy outlines, flat saturated fills', palette: 'a palette of orange, magenta, violet and lime on deep blue', framing: 'Centered, with a thick white die-cut border and an even margin of background all round.'},
    ],
    directions: ['a banjo', 'gold foil', 'jazz club'],
    directionHint: 'try: a banjo',
    seo: {
        title: 'Guitar Stickers: Vinyl Record, Treble Clef, Guitar Pick',
        metaDescription: 'Nine guitar sticker designs: a vinyl record, a treble clef with notes and a guitar pick, in glossy, punk zine and sixties styles.',
        h1: 'Guitar stickers: vinyl record, treble clef, guitar pick',
        tagline: 'Music stickers for a guitar case or body, in three finishes.',
        intro: 'Players cover guitar cases and acoustic bodies with stickers that show what they play. These nine die-cut designs show a black vinyl record with a red centre label, a treble clef with three eighth notes, and a guitar pick that reads Rock On. Each comes in glossy vinyl, a punk zine style or a sixties psychedelic poster style. You can also type a request, such as a banjo, to shape the design.',
        useCases: [
            'a sticker for a guitar case',
            'a decal on an acoustic guitar body',
            "a sticker for a music fan's laptop or amp",
            'a gift for a guitar player',
        ],
        faq: [
            {q: 'What words are on the stickers?', a: 'Only the guitar pick carries words, Rock On. The record and the clef carry no text.'},
            {q: 'Which finish suits a guitar case?', a: 'Glossy vinyl gives a clean look, punk zine a rough look and sixties psychedelic a colourful one.'},
            {q: 'Can I ask for a different music subject?', a: 'Yes, as a request, such as a banjo. The nine stickers show the record, the clef and the pick.'},
        ],
    },
}
